export enum UploadFromType {
  DRAG_AND_DROP = 'drag_and_drop',
  UPLOAD_MEDIA = 'upload_media',
  UPLOAD_ADDITIONAL_FILE = 'upload_additional_file',
}
